import script from "./ContentReactions.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentReactions.vue?vue&type=script&setup=true&lang=js"

import "./ContentReactions.vue?vue&type=style&index=0&id=0c27160c&lang=scss"

const __exports__ = script;

export default __exports__